import {ReportType} from '../../../types/report-type'
import {REPORT_FILTER_SCHEMAS} from '../filters/reportFilterSchema'

export type ReportTab = {id: string; label: string}
export type ReportDefinition = {
  title: string
  apiType: ReportType
  transport: 'standard' | 'relationship'
  format: 'standard' | 'relationship' | 'stock' | 'promotions' | 'priority'
  tabs: ReportTab[]
}
const report = (type: ReportType, overrides: Partial<ReportDefinition> = {}): ReportDefinition => ({
  title: REPORT_FILTER_SCHEMAS[type].title,
  apiType: type,
  transport: 'standard',
  format: 'standard',
  tabs: [],
  ...overrides,
})

export const REPORT_DEFINITIONS: Record<ReportType, ReportDefinition> = {
  pedidos: report('pedidos'),
  promocoes: report('promocoes', {format: 'promotions'}),
  notafiscal: report('notafiscal'),
  nota_fiscal: report('nota_fiscal', {apiType: 'notafiscal'}),
  preco_estoque_hist: report('preco_estoque_hist'),
  ultimo_preco_estoque: report('ultimo_preco_estoque', {format: 'stock'}),
  distribuidor_prioritario: report('distribuidor_prioritario', {format: 'priority'}),
  cadastro_lojistas: report('cadastro_lojistas'),
  vendedor_distribuidor: report('vendedor_distribuidor'),
  politica_preco: report('politica_preco'),
  apuracao: report('apuracao', {
    tabs: [
      {id: 'pedidos', label: 'Pedidos'},
      {id: 'sku', label: 'SKU'},
      {id: 'promos', label: 'Promoções'},
      {id: 'basePedidos', label: 'Base Pedidos'},
    ],
  }),
  sellout: report('sellout'),
  cupons: report('cupons'),
  lojistas: report('lojistas'),
  lojas_sem_compra_12_meses: report('lojas_sem_compra_12_meses'),
  lojas_quase_churn: report('lojas_quase_churn', {
    transport: 'relationship',
    format: 'relationship',
  }),
  lojas_quase_fidelizadas: report('lojas_quase_fidelizadas', {
    transport: 'relationship',
    format: 'relationship',
  }),
}
